import axios from 'axios';

export const reExtractFinancialSnapshotApi = async (customerId, customerName) => {
  const response = await axios.post(
    `/admin/customer/${customerId}/cockpit-profile/financial-snapshot/re-extract`,
    null,
    { params: customerName ? { customerName } : undefined }
  );
  return response.data;
};

export const persistAssistExtractToFinancialSnapshotApi = async (
  customerId,
  extract,
  triggeredBy
) => {
  const response = await axios.post(
    `/admin/customer/${customerId}/cockpit-profile/financial-snapshot/persist-extract`,
    { extract, triggeredBy }
  );
  return response.data;
};
